import AggregationFilter from '../../../../types/report/AggregationFilter';
import StatementHelper from '../../../types/Functions/StatementHelper';

class AggregationFilterHelper extends StatementHelper<AggregationFilter> {

    getDataSourceId(filter: AggregationFilter, _: number | null): number | null {

        return filter.dataSourceId;
    }

    getEmpty(_: number | null): AggregationFilter {

        return {
            id: null,
            dataSourceId: null,
            aggregationNumber: undefined,
            number: 0,
            condition: null as any,
            name: '',
            businessDescription: '',
            isBespoke: false,
            bespokeCondition: '',
            errors: [],
            lastUpdatedTime: undefined,
            _internalId: undefined as any
        };
    }
}

const aggregationFilterHelper = new AggregationFilterHelper();

export default aggregationFilterHelper;
